import { createContext, useContext, useState } from "react";
import useChatLogic from "../hooks/useChatLogic";
import { AuthContext } from "./AuthContext";

export const CallContext = createContext(null);

export function CallProvider({ children }) {
  const { user, token } = useContext(AuthContext);
  const [toId, setToId] = useState(null);

  const chatLogic = useChatLogic({ user, toId, token });

  return (
    <CallContext.Provider value={{ ...chatLogic, setToId }}>
      {children}
    </CallContext.Provider>
  );
}

export const useCall = () => useContext(CallContext);
